import { NgModule } from '@angular/core';
import { ModalSoftUpdateModule } from './modal-soft-update/modal-soft-update.module';

import { ModalOfflineModule } from '../delivery-list/shared/modal-offline/modal-offline.module';
import { ModalOfflineDeliveryModule } from './modal-offline-delivery/modal-offline-delivery.module';
import { ModalAssetDownloadModule } from './modal-asset-download/modal-asset-download.module';
import { ModalHelpModule } from './modal-help/modal-help.module';
import { ModalReactivateModule } from '../delivery-list/shared/modal-reactivate/modal-reactivate.module';
import { ModalDeliveryShareModule } from './modal-delivery-share/modal-delivery-share.module';
import { ModalWhatIsPpModule } from './modal-what-is-pp/modal-what-is-pp.module';
import { ModalPasscodeInquiryModule } from './modal-passcode-inquiry/modal-passcode-inquiry.module';
import { ModalMetadataModule } from './modal-metadata/modal-metadata.module';
import { ModalAppAvailabilityModule } from './modal-app-availability/modal-app-availability.module';
import { ModalForceUpdateModule } from './modal-force-update/modal-force-update.module';

const COMMON_MODULES = [
  ModalOfflineModule,
  ModalOfflineDeliveryModule,
  ModalAssetDownloadModule,
  ModalHelpModule,
  ModalReactivateModule,
  ModalDeliveryShareModule,
  ModalWhatIsPpModule,
  ModalPasscodeInquiryModule,
  ModalMetadataModule,
  ModalAppAvailabilityModule,
  ModalSoftUpdateModule,
  ModalForceUpdateModule,
];

@NgModule({
  imports: [...COMMON_MODULES],
  exports: [...COMMON_MODULES],
  declarations: [],
  providers: [],
})
export class ModalsModule {}
